const IMAGE_EXT = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.bmp',
  '.avif',
  '.webp',
  '.svg',
];

const VIDEO_EXT = ['.mp4', '.webm', '.ogv', '.ogg'];

const AUDIO_EXT = ['.mp3', '.aac', '.ogg'];

export function isImage(url: string) {
  if (!URL.canParse(url)) {
    return false;
  }

  const _url = new URL(url);

  return IMAGE_EXT.some((ext) => _url.pathname.endsWith(ext));
}

export function isVideo(url: string) {
  if (!URL.canParse(url)) {
    return false;
  }

  const _url = new URL(url);

  return VIDEO_EXT.some((ext) => _url.pathname.endsWith(ext));
}

export function isAudio(url: string) {
  if (!URL.canParse(url)) {
    return false;
  }

  const _url = new URL(url);

  return AUDIO_EXT.some((ext) => _url.pathname.endsWith(ext));
}
